import backend from 'app/backend';
import { dispatch } from 'app/store';
import CloseModal from 'app/actionCreators/CloseModal';
import { License } from 'types/license';
export default function TradeInLicense(licenseSerial: License['Serial']) {
  dispatch({
    type: 'ADD_LICENSE_TRADE_IN_TO_CART_START',
  });
  const args = {
    Serial: licenseSerial,
  };
  backend
    .dispatch('AddLicenseTradeInToCart', args)
    .then((response) => {
      if (!response.Success) {
        dispatch({
          type: 'ADD_LICENSE_TRADE_IN_TO_CART_FAIL',
          message: response.Error,
        });
        return;
      }
      dispatch({
        type: 'ADD_LICENSE_TRADE_IN_TO_CART_SUCCESS',
        licenseSerial,
      });
      dispatch({
        type: 'FETCH_SHOP_INFO_SUCCESS',
        updatedShopInfo: response.Result,
      });
      CloseModal();
    })
    .catch((error) => {
      dispatch({
        type: 'ADD_LICENSE_TRADE_IN_TO_CART_FAIL',
        message: error.message,
      });
    });
}
